function numberWithCommas(x) {
    x=   Math.round(Number(x) * 100)/100
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default numberWithCommas;